import './delete-modal-select.scss';

import { getRecordWordForm } from '@/shared/services/helpers/strings';
import { Button, Modal } from '@/shared/ui';

const correctWords = getRecordWordForm.bind(null, [
  'записей',
  'запись',
  'записи',
  'записей'
]);

interface IProps {
  isAllRowsForDelete: boolean;
  selectedRowsCount: number;
  onSubmit: () => void;
  isOpened: boolean;
  onClose: (isOpened: boolean) => void;
}

const DeleteModal: React.FC<IProps> = ({
  isAllRowsForDelete,
  selectedRowsCount,
  onSubmit,
  isOpened,
  onClose
}) => {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Modal
      className="delete-module-modal"
      classNames={{
        header: 'delete-module-modal__header'
      }}
      title="Вы хотите удалить записи из таблицы?"
      open={isOpened}
      onClose={handleClose}
    >
      <p className="delete-module-modal__description">
        Из таблицы будут удалены{' '}
        {isAllRowsForDelete
          ? 'все записи'
          : `${correctWords(selectedRowsCount)}`}
      </p>

      <div className="delete-module-modal__actions">
        <Button onClick={handleClose}>Нет</Button>
        <Button variant="filled-blue" onClick={onSubmit}>
          Да, удалить
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
